import { render, staticRenderFns } from "./modal-vote-confirm.vue?vue&type=template&id=40d4e33d&scoped=true&"
import script from "./modal-vote-confirm.vue?vue&type=script&lang=js&"
export * from "./modal-vote-confirm.vue?vue&type=script&lang=js&"
import style0 from "./modal-vote-confirm.vue?vue&type=style&index=0&id=40d4e33d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4e33d",
  null
  
)

export default component.exports